import sentinelNetwork from './sentinelNetwork';

export interface TrendPoint {
  date: string;
  score: number;
  label?: string;
}

export interface ToolReportDetail {
  tool: string;
  repoSlug: string | null;
  toolScore: number | null;
  kpiScores: Record<string, number | string | boolean>;
  topFixes: Array<{
    kpi: string;
    tool: string;
    action: string;
    location?: string;
    effort?: string;
    impact_points?: number;
    priority?: string;
  }>;
  rawReport: Record<string, any> | null;
  trendData: TrendPoint[];
  connectedTools: string[];
  /** When the raw tool data was fetched from its API (rawReport.storedAt), falling back to KPI engine analyzedAt */
  analyzedAt: string | null;
}

/**
 * Fetch a self-contained report for a single tool tab.
 * Returns scored KPIs, topFixes, raw tool report, and trend data in one call.
 */
export async function getToolReportDetail(
  appId: string,
  tool: string,
  repo?: string,
): Promise<ToolReportDetail> {
  const params: Record<string, string> = { appId, tool };
  if (repo) params.repo = repo;
  const res = await sentinelNetwork.get<{ success: boolean } & ToolReportDetail>(
    '/tool-report-detail',
    { params },
  );
  return {
    tool: res.data.tool,
    repoSlug: res.data.repoSlug,
    toolScore: res.data.toolScore,
    kpiScores: res.data.kpiScores ?? {},
    topFixes: res.data.topFixes ?? [],
    rawReport: res.data.rawReport ?? null,
    trendData: res.data.trendData ?? [],
    connectedTools: res.data.connectedTools ?? [],
    analyzedAt: res.data.analyzedAt ?? null,
  };
}
